export const GET_TEXTURE = "GET_TEXTURE";
export const SET_TEXTURE = "SET_TEXTURE";
